const LAND_PROP_START = '/api/landpropstart';
const LAND_PROP_COMPLETE = '/api/landpropcomplete';
const USER_AUTH = '/api/userauth';


export const ENDPOINTS = {
  USER_AUTH,
  LAND_PROP_START,
  LAND_PROP_COMPLETE,
};